var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.model.hasFirstYearOffer && _vm.$validateText(_vm.tooltipText))?_c('tooltip',{staticClass:"annual-fee-tooltip",attrs:{"tooltip-text":_vm.tooltipText}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }